function loadSDK() {
  if (window.AMap) return;
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'http://webapi.amap.com/maps?v=1.4.6&key=ba418638d4208d9e373b0af21b6f302c'; // ***为申请的高德key
    document.head.appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
  });
}

export default async () => {
  await loadSDK();
  return new Promise((resolve) => {
    AMap.plugin('AMap.Geolocation', () => {
      const geolocation = new AMap.Geolocation({ enableHighAccuracy: false });
      geolocation.getCurrentPosition((status, result) => {
        const res = status === 'complete' ? result.position : { lat: 39.909187, lng: 116.397451 }; // 默认北京 116.397451、39.909187
        console.log('定位结果', res);
        resolve(res);
      });
    });
  });
}
